.row {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.item {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.link {
  position: relative;
  overflow: hidden;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #ffffff;
  color: #2a2a2a;
  transition: color 0.3s ease-in-out, box-shadow 0.3s ease-in-out, transform 0.25s ease;
}

.link:hover {
  color: #ffffff;
  transform: translateY(-2px);
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.35);
}

.fill {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 0;
  background: var(--brand-fill, #1877f2);
  transition: height 0.3s ease-in-out;
  z-index: 0;
}

.link:hover .fill {
  height: 100%;
}

.icon {
  position: relative;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.tooltip {
  position: absolute;
  bottom: calc(100% + 10px);
  left: 50%;
  transform: translateX(-50%);
  padding: 5px 9px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.04em;
  color: #fff;
  background: var(--brand-fill, #1877f2);
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: opacity 0.25s ease, transform 0.25s ease, visibility 0s linear 0.25s;
}

.item:hover .tooltip {
  opacity: 1;
  visibility: visible;
  transform: translateX(-50%) translateY(-4px);
  transition: opacity 0.25s ease, transform 0.25s ease, visibility 0s linear 0s;
}
